import { type ReactNode } from 'react';
import { UnstyledLink } from '@ardoq/link';
import { toLinkProps } from 'router/declarative/toLinkProps';

type ComponentOverviewLinkProps = {
  componentId: string;
  children: ReactNode;
};

export const ComponentOverviewLink = ({
  componentId,
  children,
}: ComponentOverviewLinkProps) => (
  <UnstyledLink
    {...toLinkProps({
      route: '/component-overview/:componentId',
      params: { componentId },
    })}
    style={{ textDecoration: 'underline' }}
  >
    {children}
  </UnstyledLink>
);
